// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file cortado/v1/feedback.proto (package cortado.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { FeedbackStageEnum, FeedbackTypeEnum } from "./settings_pb";
import { file_cortado_v1_settings } from "./settings_pb";
import type { User } from "./users_pb";
import { file_cortado_v1_users } from "./users_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file cortado/v1/feedback.proto.
 */
export const file_cortado_v1_feedback: GenFile = /*@__PURE__*/
  fileDesc("Chljb3J0YWRvL3YxL2ZlZWRiYWNrLnByb3RvEgpjb3J0YWRvLnYxIuUDCghGZWVkYmFjaxIKCgJpZBgBIAEoCRIXCg9vcmdhbml6YXRpb25faWQYAiABKAkSDwoHdXNlcl9pZBgDIAEoCRIQCghmZWVkYmFjaxgEIAEoCRI1Cg5mZWVkYmFja19zdGFnZRgFIAEoDjIdLmNvcnRhZG8udjEuRmVlZGJhY2tTdGFnZUVudW0SMwoNZmVlZGJhY2tfdHlwZRgOIAEoDjIcLmNvcnRhZG8udjEuRmVlZGJhY2tUeXBlRW51bRIVCg11cHZvdGVzX2NvdW50GAYgASgFEhMKC2hhc191cHZvdGVkGAcgASgIEi4KCmNyZWF0ZWRfYXQYCiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEhIKCmNyZWF0ZWRfYnkYCyABKAkSLgoKdXBkYXRlZF9hdBgMIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASEgoKdXBkYXRlZF9ieRgNIAEoCRIuCg9jcmVhdGVkX2J5X3VzZXIYFCABKAsyEC5jb3J0YWRvLnYxLlVzZXJIAIgBARItCgh1cHZvdGVycxgVIAMoCzIbLmNvcnRhZG8udjEuRmVlZGJhY2tVcHZvdGVyQhIKEF9jcmVhdGVkX2J5X3VzZXIiSQoPRmVlZGJhY2tVcHZvdGVyEg8KB3VzZXJfaWQYASABKAkSEgoKZmlyc3RfbmFtZRgCIAEoCRIRCglsYXN0X25hbWUYAyABKAlCJlokaHViLWJhY2tlbmQvZ2VuL2NvcnRhZG8vdjE7Y29ydGFkb3YxYgZwcm90bzM", [file_google_protobuf_timestamp, file_cortado_v1_settings, file_cortado_v1_users]);

/**
 * Feedback represents user feedback or feature requests
 *
 * @generated from message cortado.v1.Feedback
 */
export type Feedback = Message<"cortado.v1.Feedback"> & {
  /**
   * Unique identifier for the feedback
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Organization ID the feedback belongs to
   *
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * User ID who submitted the feedback
   *
   * @generated from field: string user_id = 3;
   */
  userId: string;

  /**
   * Feedback content
   *
   * @generated from field: string feedback = 4;
   */
  feedback: string;

  /**
   * Current stage/status of the feedback
   *
   * @generated from field: cortado.v1.FeedbackStageEnum feedback_stage = 5;
   */
  feedbackStage: FeedbackStageEnum;

  /**
   * Type/category of the feedback
   *
   * @generated from field: cortado.v1.FeedbackTypeEnum feedback_type = 14;
   */
  feedbackType: FeedbackTypeEnum;

  /**
   * Number of upvotes this feedback has received
   *
   * @generated from field: int32 upvotes_count = 6;
   */
  upvotesCount: number;

  /**
   * Whether the current user has upvoted this feedback
   *
   * @generated from field: bool has_upvoted = 7;
   */
  hasUpvoted: boolean;

  /**
   * Created at timestamp
   *
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */
  createdAt?: Timestamp;

  /**
   * Created by user ID
   *
   * @generated from field: string created_by = 11;
   */
  createdBy: string;

  /**
   * Updated at timestamp
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 12;
   */
  updatedAt?: Timestamp;

  /**
   * Updated by user ID
   *
   * @generated from field: string updated_by = 13;
   */
  updatedBy: string;

  /**
   * Enriched user data for list views
   *
   * @generated from field: optional cortado.v1.User created_by_user = 20;
   */
  createdByUser?: User;

  /**
   * Users who have upvoted this feedback
   *
   * @generated from field: repeated cortado.v1.FeedbackUpvoter upvoters = 21;
   */
  upvoters: FeedbackUpvoter[];
};

/**
 * Describes the message cortado.v1.Feedback.
 * Use `create(FeedbackSchema)` to create a new message.
 */
export const FeedbackSchema: GenMessage<Feedback> = /*@__PURE__*/
  messageDesc(file_cortado_v1_feedback, 0);

/**
 * Lightweight user info for upvote display
 *
 * @generated from message cortado.v1.FeedbackUpvoter
 */
export type FeedbackUpvoter = Message<"cortado.v1.FeedbackUpvoter"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string first_name = 2;
   */
  firstName: string;

  /**
   * @generated from field: string last_name = 3;
   */
  lastName: string;
};

/**
 * Describes the message cortado.v1.FeedbackUpvoter.
 * Use `create(FeedbackUpvoterSchema)` to create a new message.
 */
export const FeedbackUpvoterSchema: GenMessage<FeedbackUpvoter> = /*@__PURE__*/
  messageDesc(file_cortado_v1_feedback, 1);

